

import { 
    Container
} from "react-bootstrap";
import PDFPage6Table1 from "./pdf-page-6/PDFPage6Table1";
import PDFPage6Table2 from "./pdf-page-6/PDFPage6Table2";
import PDFPage6Table3 from "./pdf-page-6/PDFPage6Table3";
import ExternalPDFPage6Table3 from "./external/ExternalPDFPage6Table3";
import PDFPage6Table4 from "./pdf-page-6/PDFPage6Table4";
import PDFPage6Table5 from "./pdf-page-6/PDFPage6Table5";
import PDFPage6DisclamerEdit from "./pdf-page-6/PDFPage6DisclamerEdit";
import CustomMap from "components/shared/map/CustomMap";
import { useEffect, useState } from "react";
import LtvAnalysisServices from "services/services/LtvAnalysisServices";

function PDFPage6(props: any) {
    const [dimensions, setDimensions] = useState({ height: 500 });
    const [locationData, setLocationData] = useState();

    useEffect(() => {
        initialRenderData();
    }, [props])

    const initialRenderData = () => {
        let object: any = {};
        object.customer_id = props?.id;
        // setLoading(true);
        let modifyArr = props?.ltvDetails?.hsp_sales_data_location;
                modifyArr = modifyArr?.map((val: any) => {
                    return { location: { lat: parseFloat(val?.lat), lng: parseFloat(val?.long) }, sale_data_num_rooms: val?.sale_data_num_rooms }
                });
        setLocationData(modifyArr);
        
        // LtvAnalysisServices
        // .getLtvData(object)
        // .then((response: any) => {
        //     if (response?.data?.code === 200) {
        //         const responseData = response?.data?.data;
        //         let propertyType = responseData?.customer_data?.filter_property_type !== "" ? responseData?.customer_data?.filter_property_type.split(',') : [];
        //         let ownershipType = responseData?.customer_data?.filter_ownership_type !== "" ? responseData?.customer_data?.filter_ownership_type.split(',') : [];
        //         let modifyArr = responseData?.hsp_sales_data_location;
        //         modifyArr = modifyArr?.map((val: any) => {
        //             return { location: { lat: parseFloat(val?.lat), lng: parseFloat(val?.long) }, sale_data_num_rooms: val?.sale_data_num_rooms }
        //         });
        //         setLocationData(modifyArr);
        //     }
        //     // setLoading(false);
        // })
        // .catch((err: any) => {
        //     console.log(err)
        //     // setLoading(false);
        // });
    }
    return (
        <>
            <Container fluid className="text-left page-break cu-pt-10" >
                { <h3 className="cu-fs-18">{props.TranslateString('LTV analysis - market-based indicative value estimation')}​ ​</h3> }
                <div className="row" style={{minHeight: '510px'}}>
                    <div className="col-sm-8 pe-2 d-flex flex-column justify-content-between">
                    <PDFPage6Table1 {...props} loanData={props?.ltvDetails?.loanData} loanData_total={props?.ltvDetails?.loanData_total}/> 
                    <PDFPage6Table2 {...props} ltvDetails={props?.ltvDetails}/>
                    { props?.loanPriority && props?.loanPriority == '13' 
                       ? <ExternalPDFPage6Table3 {...props} ltvDetails={props?.ltvDetails} data={props?.ltvDetails?.apartment_data}/>
                       : <PDFPage6Table3 {...props} ltvDetails={props?.ltvDetails} data={props?.ltvDetails?.apartment_data}/>
                    }
                    <PDFPage6Table4 {...props} data={props?.ltvDetails?.business_space_data}/>
                    <PDFPage6Table5 {...props} data={props?.ltvDetails?.car_space_data}/>
                    </div>
                    <div className="col-sm-4 overflow-hidden">
                        <div className="card card-body rounded-0 border border-dark p-1 google_map_canvas" style={{ height: '150%'}}>
                            <CustomMap
                                type={'pdf'}
                                locations={locationData}
                            />
                        </div>
                    </div>
                </div>
                {/* <PDFPage6DisclamerEdit {...props}/> */}
            </Container>
        </>
    );
}

export default PDFPage6;